import * as React from 'react';
import { filter } from 'lodash';

import { DefaultButton } from '@magoosh/lib/button';
import { StudyScheduleData, StudyScheduleDetailData } from '../types';

interface Props {
  currentPlan: StudyScheduleDetailData;
  onCancel: (any) => void;
  onComplete: (id: number) => void;
  plans: StudyScheduleData[];
}

export default ({ currentPlan, onCancel, onComplete, plans }: Props) => {
  const alternativePlans = filter(plans, (plan) => plan.id !== currentPlan.id);

  return (
    <div className="u-padding-A-m">
      <h4 className="u-margin-V-n"><strong>Change Your Study Plan</strong></h4>

      <div className="u-margin-T-m">
        You are currently using our {currentPlan.name} Plan.
      </div>
      <hr />

      <div className="u-margin-T-s">
        <p>Not quite right? Choose from one of our other study plans below.</p>
        {
          alternativePlans.map((plan) => (
            <DefaultButton
              block
              className="u-margin-V-s"
              data={plan.id}
              key={plan.id}
              onClick={onComplete}>
              {plan.name}
            </DefaultButton>
          ))
        }
      </div>

      <div className=" text-center u-margin-T-m">
        <a className="text-gray-light" onClick={onCancel}>Go Back</a>
      </div>
    </div>
  );
}
